import { CaretRight } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";
import { SectionLabel } from "@/components/ui/section-label";
import { cn } from "@/lib/utils";

type SidebarSectionToggleProps = {
  label: string;
  open: boolean;
  onToggle: () => void;
  labelDataAttr?: boolean;
};

/** Collapsible sidebar section header (Channels, DMs, Workspaces, …). */
export function SidebarSectionToggle({
  label,
  open,
  onToggle,
  labelDataAttr,
}: SidebarSectionToggleProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onToggle}
      className="h-auto gap-1 px-0 py-0 font-semibold hover:bg-transparent"
    >
      <SectionLabel
        variant="sidebar"
        {...(labelDataAttr ? { "data-sidebar-section-label": true } : {})}
      >
        {label}
      </SectionLabel>
      <CaretRight
        size={8}
        weight="Bold"
        className={cn(
          "text-muted-foreground/50 transition-transform duration-150",
          open && "rotate-90",
        )}
      />
    </Button>
  );
}

/** Compact control inside section header pills (filter label, + button). */
export const SIDEBAR_PILL_BUTTON =
  "h-auto rounded-none px-1.5 py-0.5 text-[9px] font-normal text-muted-foreground/50 hover:bg-foreground/10 hover:text-muted-foreground";

export const SIDEBAR_PILL_ICON_BUTTON =
  "h-auto rounded-none px-1 py-0.5 font-normal text-muted-foreground/50 hover:bg-foreground/10 hover:text-muted-foreground";
